<template>
  <v-dialog
    v-if="UnreadedWarnings.length"
    v-model="showModalwarnings"
    overlay-color="bg-dark-overlay"
    overlay-opacity="0.90"
    width="90vw"
    max-width="800px"
    :persistent="!hasNotBlockWarnings"
  >
    <v-card class="bg-white">
      <v-card-title class="row pb-0 m-0 px-4 d-flex justify-content-between">
        <span>
          {{ currentWarning.title }}
        </span>
        <div class="pr-0">
          <BtnClose
            v-if="hasNotBlockWarnings"
            @click="SHOW_WARNINGS(false)"
          />
        </div>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-2 pb-4 main-content-modal d-flex flex-column justify-content-between overflow-auto">
        <div
          style="height: 50vh; overflow-y:scroll"
          v-html="currentWarning.content"
        />
        <div>
          <div class=" d-flex flex-column flex-md-row justify-content-md-between align-items-md-center mt-md-3 ">
            <div class="warnings-controllers mb-2 mb-md-0">
              <div
                v-for="(warning, key) in UnreadedWarnings"
                :key="warning.id"
                :class="{ 'bg-nitro': index === key }"
                class="circle-slider-controller pointer-on-hover"
                @click="index = key"
              />
            </div>
            <v-btn
              v-if="!currentWarning.is_persistent"
              color="nitro"
              class="text-white"
              @click="onClickDontShowAgain"
            >
              Não mostrar novamente
            </v-btn>
            <v-btn
              v-if="currentWarning.redirect_link"
              color="nitro"
              class="text-white"
              :href="currentWarning.redirect_link"
              :alt="currentWarning.button_link_name"
              target="_blank"
            >
              {{ currentWarning.button_link_name }}
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import BtnClose from "@/common/components/BtnClose";

export default {
  components: {BtnClose},
  data() {
    return {
      index: 0,
    }
  },
  computed: {
    ...mapState({
      showModalwarnings: state => state.warnings.showWarnings,
    }),
    ...mapGetters(['UnreadedWarnings','hasNotBlockWarnings']),
    currentWarning() {
      return this.UnreadedWarnings[this.index]
    }
  },
  methods: {
    ...mapActions(['markWarningAsRead']),
    ...mapMutations(['SHOW_WARNINGS']),
    onClickDontShowAgain(){
      this.markWarningAsRead(this.currentWarning.id);
      this.index = 0;
    },
  }
}
</script>

<style lang="scss" scoped>
input .checkbox-warning {
  height: 25px;
}

.main-content-modal {
  min-height: 300px;
  max-height: 60vh;

  & > :first-child {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: black;
  }
}

.select-warning {
  // font-size: 20px;
  @media (min-width: 768px) {
    max-width: 150px;
  }
}

.circle-slider-controller {
  background: white;
  border-radius: 50%;
  border: 1px solid black;
  height: 20px;
  width: 20px;
}

.alert-carousel-buttons-current {
  background: yellow !important;
}

.warnings-controllers {
  display: flex;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 5px;
  }
}
</style>
